import { formatDateForApi } from "@/utils";
import type { ServiceResponse } from "../api.types";
import { privateAPI } from "../axios";
import type {
  CheckPatientStatusResponse,
  DisqualifiedPatient,
  DisqualifyPatientRequest,
} from "./patients.types";

export async function checkPatientStatus(
  firstName: string,
  lastName: string,
  birthdate: string,
): Promise<CheckPatientStatusResponse> {
  const { data } = await privateAPI.get<
    ServiceResponse<CheckPatientStatusResponse>
  >(`/patients/search`, {
    params: {
      firstName,
      lastName,
      dateOfBirth: birthdate,
    },
  });

  return data.data;
}

export async function disqualifyPatient({
  firstName,
  lastName,
  dateOfBirth,
  email,
  reasonToDisqualify,
}: DisqualifyPatientRequest): Promise<DisqualifiedPatient> {
  const formattedDate = formatDateForApi(dateOfBirth);
  const { data } = await privateAPI.post<ServiceResponse<DisqualifiedPatient>>(
    `/patients/disqualify`,
    {
      firstName,
      lastName,
      dateOfBirth: formattedDate,
      email,
      reasonToDisqualify,
    },
  );

  return data.data;
}
